var Control = require("enyo/Control"),
    kind    = require("enyo/kind");

require("enyo-ui");
require("./ScrollerDecoratorClient.css");

/**
 * [ScrollerDecoratorClient]{@link enyo-ui.ScrollerDecoratorClient} is a control
 * that wraps around the contents of the
 * [ScrollerDecorator]{@link enyo-ui.ScrollerDecorator}. It prevents unnecessary
 * resizing by explicitly checking if the dimensions of the client have actually
 * changed.
 *
 * This control is not meant for internal usage by
 * [ScrollerDecorator]{@link enyo-ui.ScrollerDecorator} only.
 *
 * @ui
 * @class   enyo-ui.ScrollerDecoratorClient
 * @extends enyo.Control
 * @private
 */
module.exports = kind(/** @lends  enyo-ui.ScrollerDecoratorClient.prototype */ {

    /**
     * @private
     */
    name: "enyo-ui.ScrollerDecoratorClient",

    /**
     * @private
     */
    kind: Control,

    /**
     * @private
     */
    classes: "enyo-ui-scroller-decorator-client",

    /**
     * @private
     */
    cachedBounds: null,

    /**
     * Whether the client actually did resize the last time the `onresize` event
     * was handled.
     *
     * @type     {boolean}
     * @default  false
     * @readonly
     * @public
     */
    didResize: false,

    /**
     * @private
     */
    handlers: {
        onpostresize: "handlePostresize"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.controlParent = this.$.controlParent;
        };
    }),

    /**
     * Only reflows if this client did actually resize. If not, we won't reflow
     * and stop propagating the `onresize` event.
     *
     * @returns  {boolean}  Whether to stop propagation.
     * @private
     */
    handleResize: function() {
        var cachedBounds = this.cachedBounds || {},
            bounds       = this.getBounds();

        this.didResize = bounds.width !== cachedBounds.width
            || bounds.height !== cachedBounds.height;

        this.cachedBounds = bounds;

        // When size is 0 pixels wide or high we don't want to prevent resize,
        // because it might be caused by components that defer rendering until
        // after receiving their `resize` event.
        return bounds.width > 0
            && bounds.height > 0
            && !this.didResize;
    },

    /**
     * Cache bounds immediately after rendering. This prevents them from always
     * being changed when the initial chrome configuration is applied to the
     * ScrollerDecorator.
     *
     * @method
     * @private
     */
    rendered: kind.inherit(function(sup) {
        return function() {
            this.cachedBounds = this.getBounds();
            sup.apply(this, arguments);
        };
    }),

    /**
     * Stop propagating the `onpostresize` event if the client didn't actually
     * resize.
     *
     * @returns  {boolean}  Whether to stop propagation.
     * @private
     */
    handlePostresize: function() {
        var bounds = this.cachedBounds;

        // When size is 0 pixels wide or high we don't want to prevent resize,
        // because it might be caused by components that defer rendering until
        // after receiving their `postresize` event.
        return bounds.width > 0
            && bounds.height > 0
            && !this.didResize;
    }

});
